import { gql } from '@apollo/client'
import { DISPLAY_FACING_ITEM_FRAGMENT } from './DisplayFacingItemFragment'

export const SHELF_SCAN_FRAGMENT = gql`
  fragment ShelfScan on ShelfScan {
    facings {
      ...DisplayFacingItem
    }
    score
    shelfIndex
  }
  ${DISPLAY_FACING_ITEM_FRAGMENT}
`
